<template>
  <div>
    <ItemRow>
      <ItemWithLabel
        :column="columns[0]"
      >
        <Link
          :class="$style.link"
          :text="itemData.name"
          :to="editLink"
        />
      </ItemWithLabel>
      <ItemWithLabel
        :column="columns[1]"
      >
        <Icon
          :icon="systemOsIcon"
          inline
          :scale="1"
          :text="systemOsLabel"
        />
        <span>{{ systemOsLabel }}</span>
      </ItemWithLabel>
      <ItemWithLabel
        :column="columns[2]"
      >
        {{ itemData.pendingCount }}
      </ItemWithLabel>
      <ItemWithLabel
        :column="columns[3]"
      >
        {{ queuedAt }}
      </ItemWithLabel>
      <ItemWithLabel
        :class="$style.cancelCommandButton"
        :column="columns[4]"
      >
        <ButtonGroup
          title="Running commands cannot be canceled"
        >
          <Button
            hasOutline
            :isDisabled="noCommandsToCancel"
            text="Cancel Command"
            type="error"
            @click="handleShowCancelModal(true)"
          />
        </ButtonGroup>
      </ItemWithLabel>
    </ItemRow>

    <CommandQueueCancelModal
      :itemData="itemData"
      :showModal="showCancelModal"
      @continue="handleCancelContinue()"
      @show="value => handleShowCancelModal(value)"
    />
  </div>
</template>

<script>
import {
  Button,
  ButtonGroup,
  Icon,
  ItemRow,
  ItemWithLabel,
  Link,
} from '@jumpcloud/ui-components';
import { mapActions } from 'vuex';
import { notify } from 'client/util';
import CommandQueueCancelModal from 'client/Commands/CommandQueueCancelModal.vue';
import CommandTypes from 'client/Commands/constants/CommandTypes';
import DateUtil from 'client/util/DateUtil';
import UtilConstants from 'client/util/Constants';

const { linux, windows, mac } = CommandTypes;
const { error, success, dataNotAvailable } = UtilConstants;

export default {
  name: 'CommandQueueRow',
  components: {
    Button,
    ButtonGroup,
    CommandQueueCancelModal,
    Icon,
    ItemRow,
    ItemWithLabel,
    Link,
  },

  props: {
    columns: {
      type: Array,
      default: () => ([]),
    },
    itemData: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      showCancelModal: false,
    };
  },

  computed: {
    editLink() {
      return `/commandqueue/${this.itemData.workflowInstanceId}/details`;
    },

    noCommandsToCancel() {
      return this.itemData.pendingCount === 0;
    },

    queuedAt() {
      return DateUtil.formatDateTime(this.itemData.createDate);
    },

    systemOsIcon() {
      const iconMap = {
        [linux]: 'linux',
        [windows]: 'windows',
        [mac]: 'apple',
      };

      return iconMap[this.itemData.operatingSystem] || dataNotAvailable;
    },

    systemOsLabel() {
      const { operatingSystem } = this.itemData;
      return operatingSystem.charAt(0).toUpperCase() + operatingSystem.slice(1);
    },
  },

  methods: {
    ...mapActions('CommandQueueWorkflowCollection', [
      'cancelCommandQueue',
    ]),

    handleCancelContinue() {
      return this.cancelCommandQueue(this.itemData)
        .then((status) => {
          if (status === 204) {
            notify(success, 'Successfully canceled queued command.');
          } else {
            notify(error, 'No command was queued.');
          }
        })
        .catch(() => {
          notify(error, 'An error occurred when trying to cancel the queued command.');
        })
        .finally(async () => {
          this.handleShowCancelModal(false);
        });
    },

    handleShowCancelModal(state) {
      this.showCancelModal = state;
    },
  },
};
</script>

<style module scoped>

.link.link {
  display: inline;
}

.cancelCommandButton {
  width: 13em;
}
</style>
